module.exports = __webpack_public_path__ + "static/tab-c2bcc2eae249eb3e1426dcc5bcc9777b.jpg";